module.exports = __webpack_public_path__ + "img/激活标题背景.b1de76bd.png";